module.exports = __webpack_public_path__ + "media/images/switch-off-55a02ce1826d2a7aad95a7c3ab2a3f18.svg";